module.exports = __webpack_public_path__ + "img/logo-labmanagerpro.6aa3e385.svg";